import axios from 'axios';
import { useSelector } from 'react-redux';

import { getV2RootUrl, publicAxiosHeaderV2 } from 'common/helpers/apiHelper';

export const useLocalization = () => {
  const langObj = useSelector((state) => state.localization.data);

  const getResourceValue = (languageObject, resourceKey) => {
    const keys = resourceKey.split('.');
    if (languageObject) {
      let value = languageObject;

      // Loop through the resourceKey array until find the value in nested object.
      for (const key of keys) {
        if (value && key in value) {
          value = value[key];
        } else {
          const message = {
            text: `Translation key '${resourceKey}' not found.`
          };
          consoleToSlack(message);
          return undefined;
        }
      }
      return value;
    }
    return null;
  };

  const translation = (resourceKey, replacements) => {
    let resource = getResourceValue(langObj, resourceKey);

    if (resource && replacements) {
      // Replace placeholders with values from the replacements object
      Object.entries(replacements).forEach(([key, value]) => {
        resource = resource.replace(new RegExp(`{{${key}}}`, 'g'), value);
      });
    }

    return resource;
  };

  return { t: translation, resourceBundle: langObj };
};

export const consoleToSlack = async (message) => {
  await axios.post(
    `${getV2RootUrl()}/slack-chat`,
    { message },
    publicAxiosHeaderV2()
  );
};
